import { createUseStyles } from "react-jss";
import { foregroundColor, alpha, controlBackgroundColor, getSpacing } from "../../../theme/Mixins";

export default createUseStyles({
    imageArea: {
        border: ({ theme }) => [[theme.BorderWidth, "solid", theme.ControlBorderColor]],
        borderRadius: ({ theme }) => theme.BorderRadius,
        composes: "image-area",
        display: "inline-block",
        fontSize: 0,
        lineHeight: 0,
        maxWidth: "100%",
        overflow: "hidden",
        position: "relative",
        marginTop: ({ theme }) => getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents),
    },
    imageAreaImage: {
        composes: "image-area__image",
        lineHeight: 0,
        maxWidth: "100%",
        position: "relative",
    },
    imageAreaLegend: {
        composes: "image-area-legend",
        background: ({ theme }) => alpha(theme.ControlBackground, theme.ControlAlpha),
        border: ({ theme }) => [[theme.BorderWidth, "solid", theme.ControlBorderColor]],
        borderRadius: ({ theme }) => theme.BorderRadius,
        color: ({ theme }) => foregroundColor(theme, controlBackgroundColor(theme)),
        display: "flex",
        marginTop: ({ theme }) => getSpacing(theme, 18, theme.QuestionSpacing?.WithinComponents),
        padding: 9,
    },
    dynamicImageAreaLegend: {
        flexWrap: "wrap",
    },
    imageAreaLegendTitle: {
        composes: "image-area-legend__title",
        alignSelf: "center",
        flex: 1,
        fontWeight: 600,
        margin: [[0, 20]],
    },
    imageAreaLegendList: {
        display: "flex",
        flexWrap: "wrap",
        flex: 3,
        composes: "image-area-legend__list",
    },
    initialFlex: {
        flex: "auto",
    },
    imageAreaLegendContainer: {
        composes: "image-area-legend__container",
        margin: [[4, 20]],
        display: "flex",
        alignItems: "center",
    },
    imageAreaLegendColor: {
        borderRadius: ({ theme }) => Math.min(theme.BorderRadius, 12.5),
        composes: "image-area-legend__color",
        display: "inline-block",
        height: 25,
        marginRight: 15,
        verticalAlign: "middle",
        width: 25,
    },
    imageAreaLegendText: {
        composes: "image-area-legend__text",
        display: "inline-block",
        verticalAlign: "middle",
    },
});
